<template>
  <div class="dygc-footer-bottom-mobile">
    <p>Copyright &#169; 2010-{{ currentYear }} 调研工厂 使用即表示同意 <span @click="toUrl(userAgreement)">用户协议</span> |</p>
    <p>
      <span @click="toUrl(privacyPolicy)">隐私政策</span> |
      <img src="./assets/iso.svg" />
      已通过ISO27001信息安全认证
      <span class="cursor" v-if="isReport" @click="toUrl(report)"> | 举报</span>
    </p>
  </div>
</template>

<script>
import mixin from './mixin'
export default {
  mixins: [mixin]
}
</script>

<style lang="scss" scoped>
.dygc-footer-bottom-mobile {
  opacity: 0.25;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
  text-align: center;
  min-height: 22px;
  line-height: 22px;
  img {
    width: 14px;
    height: 12px;
    vertical-align: middle;
  }
  p,
  span {
    font-size: 12px;
  }
}
</style>
